<template>
  <div id="app" v-if="ready" v-loading="loading">
    <el-container>
      <el-header>
        <navbar></navbar>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <!-- <setcollections ref="setcollections" v-show="false"></setcollections> -->
  </div>
</template>

<script>
import navbar from "@/components/navbar";
// import {
//   chartdataxy,
//   chartdatagroup,
//   renewitems
// } from "@/components/utility/indexdb";
// import setcollections from "@/components/utility/setcollections.js"
export default {
  components: { navbar },
  name: "App",
  mounted() {
    this.$axios.appinitial()
  },

  computed: {
    //用于判断是否具备显示条件
    ready(){return this.$store.state.user ||this.$router.currentRoute.path==="/login"},
    loading() {
      return this.$store.state.loading;
    }
  }
};
</script>

<style>
#app {
  /* height: 100vh; */
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-size:0.8em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background:#fff1e5;
  
}

header.el-header {height:35px !important;padding: 0 10px;}

.el-main{padding:0 10px}

</style>



// WEBPACK FOOTER //
// src/App.vue